import {RecordKind} from 'core/Record';
import {createFactoryFor} from './factory';

export const createSpend = createFactoryFor(RecordKind.Spend);
export const createIncome = createFactoryFor(RecordKind.Income);
export const createRefill = createFactoryFor(RecordKind.Refill);
